import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { TableCell, TableRow } from '@/Domain/components/Shared/Table/Table';

export const ErrorTableRow = () => {
  const { t } = useTranslation('insights_page', { keyPrefix: 'general' });
  const handleClick = () => window.location.reload();

  return (
    <TableRow className="hover:!bg-transparent mx-auto border-b-0">
      <TableCell colSpan={4} className="text-center text-sm font-medium text-red-600 space-y-2">
        <p>{t('error')}</p>
        <Button variant="dark" onClick={handleClick}>
          {t('retry')}
        </Button>
      </TableCell>
    </TableRow>
  );
};
